<template>
    <div class="order-infoTab-section1">
        <div class="order-pay-record">
            <el-table :data="logs" border style="width: 100%" class="tabTopBorder" v-loading="loading">
                <el-table-column type="expand">
                    <template slot-scope="props">
                        <el-row :gutter="20">
                            <el-col :span="10" v-if="props.row.context.length > 0">
                                <p v-html="props.row.context"></p>
                            </el-col>
                        </el-row>
                        <!--                        <p v-if="props.row.messages.length > 0">-->
                        <!--                            <span v-for="(message, index) in props.row.messages">-->
                        <!--                                <label>{{message.label}}</label> : {{message.value}}-->
                        <!--                            </span>-->
                        <!--                        </p>-->
                    </template>
                </el-table-column>
                <el-table-column prop="created_at" label="操作时间"></el-table-column>
                <el-table-column prop="operater_username" label="操作人"></el-table-column>
                <el-table-column prop="operate_type_text" label="操作类型"></el-table-column>
                <el-table-column prop="memo" label="备注"></el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import CustomerService from "~/services/customer.js";
    import Pagination from "~/widgets/Pagination.vue";
    import Rule from "~/services/Rule";

    export default {
        name: "RuleOperateLog",
        components: {
            Pagination
        },
        data() {
            return {
                logs: [],
                linkPage: null,
                loading: true,
                type:'',
                params:[]
            }
        },
        created() {
            if (this.logs.length == 0) {
                this.getLogs({
                    type: this.$route.query["type"],
                })
            }
        },
        methods: {

            getLogs(params) {
                Rule.lookLog(params).then(res => {
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                        this.loading = false;
                    }
                })
            },

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.getLogs({
                    type: this.$route.query["type"],
                    page: pageParams["page"],
                    perPage: pageParams["perPage"]
                });
            },

        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/login-rules/lookLogs.vue